<template>
  <div>
    <div class="bk-blue secret-blue">
      <div class="container">
        <img class="icon-imunitate" src="../../assets/images/pentru-imunitate/logo3.png"  style="width: 97px; height: 60px">
        <h1 class="title-ap">Ce determină scăderea imunității?</h1>
      </div>
    </div>

    <div class="container d-none d-md-flex" >
      <div class="row immunity-cards">
        <div class="bk-gray-dark card col-md-3" style="margin: 7px">
          <h3>Alimentația nepotrivită</h3>
          <p>O dietă bogată în calorii, dar care nu oferă necesarul de vitamine și minerale.</p>
        </div>
        <div class="bk-gray-dark card col-md-3" style="margin: 7px  ">
          <h3>Lipsa expunerii la mediul înconjurător</h3>
          <p>sistemul imunitar nu este antrenat suficient.</p>
        </div>
        <div class="bk-gray-dark card col-md-3" style="margin: 7px">
          <h3>Igiena incorectă mai ales la intrarea în colectivitate</h3>
          <p>când riscul este mai mare.</p>
        </div>
        <div class="bk-gray-dark card col-md-3" style="margin: 7px">
          <h3>Oboseala și tulburarea programului de somn</h3>
          <p>extenuarea slăbește sistemul imunitar.</p>
        </div>
      </div>
    </div>

    <carousel :nav="false" :items=1 :stagePadding=20 :center=true  class="immunity-cards-carousel d-flex d-md-none">
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Alimentația nepotrivită</h3>
          <p>O dietă bogată în calorii, dar care nu oferă necesarul de vitamine și minerale.</p>
        </div>
      </div>
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Lipsa expunerii la mediul înconjurător</h3>
          <p>sistemul imunitar nu este antrenat suficient.</p>
        </div>
      </div>
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Igiena incorectă mai ales la intrarea în colectivitate</h3>
          <p>când riscul este mai mare.</p>
        </div>
      </div>
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Oboseala și tulburarea programului de somn</h3>
          <p>extenuarea slăbește sistemul imunitar.</p>
        </div>
      </div>
    </carousel>

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'


export default {
  components: { carousel},
  props: ["mobile_component"],

}



</script>
<style scoped lang="scss">
.immunity-cards{
  margin: 30px 0;
  display: flex;
  justify-content: space-between;

}

.immunity-cards-carousel{
  margin-top: 20px;
}
</style>